import styled, { css } from 'styled-components';

type ContainerProps = {
  checked?: boolean;
};

export const Container = styled.li<ContainerProps>`
  min-width: 40.1rem;
  height: 6.3rem;
  background: #ffffff;
  border-radius: 0.4rem;

  cursor: pointer;

  margin-bottom: 3rem;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${({ checked }) =>
    !checked &&
    css`
      svg {
        transform: scaleX(-1);
      }
    `}

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 2.9rem;
`;

export const Label = styled.p`
  font-weight: bold;
  font-size: 1.8rem;
`;
